"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    autoBind: Boolean,
    columns: Array,
    resizable: Boolean,
    reorderable: Boolean,
    columnMenu: Boolean | Object,
    dataSource: Object | Array,
    editable: Boolean | Object,
    excel: Object,
    filterable: Boolean | Object,
    height: Number | String,
    messages: Object,
    navigatable: Boolean,
    pageable: Boolean | Object,
    pdf: Object,
    scrollable: Boolean | Object,
    selectable: Boolean | String,
    sortable: Boolean | Object,
    toolbar: String | Function | Array,

    // Events
    beforeEdit: Function,
    cancel: Function,
    cellClose: Function,
    change: Function,
    collapse: Function,
    dataBinding: Function,
    dataBound: Function,
    dragstart: Function,
    drag: Function,
    dragend: Function,
    drop: Function,
    edit: Function,
    excelExport: Function,
    expand: Function,
    filterMenuInit: Function,
    pdfExport: Function,
    remove: Function,
    save: Function,
    columnShow: Function,
    columnHide: Function,
    columnReorder: Function,
    columnResize: Function,
    columnMenuInit: Function,
    columnLock: Function,
    columnUnlock: Function
};